module.exports = __webpack_public_path__ + "img/kr-product-footer-banner-bg.84509a9.png";